import { ApiError } from '../shared/shared-http.models';

export class ErrorMessages {
  /* eslint-disable @typescript-eslint/naming-convention */
  private static errors: Record<string, string> = {
    validation_exception: 'Validation error.',
    staff_file_not_found:
      'Unable to download Certificate as the file has not been found.',
  };
  /* eslint-enable @typescript-eslint/naming-convention */

  public static mapErrorMessage(error: ApiError): string {
    let message = '';
    const definedError = ErrorMessages._getErrorString(error);
    if (definedError) {
      message += `${definedError}`;
      if (error.code === 'validation_exception') {
        message += ` ${error.message}`;
      }
    } else {
      message += error.message;
    }

    return message;
  }

  private static _getErrorString(error: ApiError): string {
    return ErrorMessages.errors[error.code];
  }
}
